module.exports = __webpack_public_path__ + "img/5.13689414.png";